<table class="table align-middle table-bordered fs-6 rounded-3 rounded-bottom-0 overflow-hidden m-0">
  <thead>
    <tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-primary-subtle">
      <th class="text-nowrap text-center">Deposited Payment</th>
    </tr>
  </thead>
</table>
<table class="table align-middle table-bordered fs-6 rounded-3 rounded-top-0 overflow-hidden m-0">
  <thead>
    <tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-primary-subtle">
      <th class="text-nowrap">REF No.</th>
      <th class="text-nowrap">Date</th>
      <th class="text-nowrap">Terms</th>
      <th class="text-nowrap">Amount</th>
      <th class="text-nowrap">Ex.Rate</th>
      <th class="text-nowrap">Allocated</th>
      <th class="text-nowrap">Available</th>
    </tr>
  </thead>
  <tbody class="text-gray-600 fw-semibold">
    <tr *ngIf="isLoading">
					<td colspan="20" class="text-center py-5">
						<div class="d-flex justify-content-center align-items-center">
							<span class="spinner-border spinner-border-sm me-2"></span>
							Loading deposits...
						</div>
					</td>
    </tr>
    <tr *ngIf="!isLoading && deposits.length === 0">
      <td colspan="7" class="text-center py-4">No deposits found for this client.</td>
    </tr>
    <tr *ngFor="let deposit of deposits"
        (click)="selectDeposit(deposit)"
        [class.selected-row]="isSelected(deposit)"
        style="cursor: pointer;">
      <td class="text-nowrap text-center">
        <div class="deposit-hover-container"
             (click)="toggleTooltip($event, deposit)">
          <span class="deposit-ref-trigger">{{ deposit.reference_number }}</span>
          <div class="deposit-details-popup" #tooltipPopup>
            <div class="popup-header">
              <button type="button" class="btn-close-popup" (click)="closeTooltip($event)">
                <i class="ki-duotone ki-cross fs-2">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
              </button>
            </div>
            <table class="table align-middle table-bordered fs-6 rounded-3 overflow-hidden m-0">
              <thead>
                <tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-primary-subtle">
                  <td>Invoice No.</td>
                  <td>Chassis No.</td>
                  <td>Paid Amount</td>
                </tr>
              </thead>
              <tbody class="text-gray-600 fw-semibold">
                <tr *ngFor="let allocation of deposit.allocations">
                  <td class="text-nowrap">{{ allocation.invoice_no }}</td>
                  <td class="text-nowrap">{{ allocation.chassis_no }}</td>
                  <td class="text-nowrap">{{ allocation.currency_type == 'usd' ? '$' : '¥' }} {{ allocation.allocate_amount | number:'1.0-0' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </td>
      <td class="text-nowrap">{{ deposit.received_date | date:'yyyy-MM-dd' }}</td>
      <td class="text-nowrap">{{ deposit.payment_type | uppercase }}</td>
      <td class="text-nowrap">{{ deposit.customer.currency_type == 'usd' ? '$' : '¥' }} {{ deposit.received_amount | number:'1.0-0' }}</td>
      <td class="text-nowrap">{{ deposit.ex_rate }}</td>
      <td class="text-nowrap">{{ deposit.customer.currency_type == 'usd' ? '$' : '¥' }} {{ deposit.amount_allocated | number:'1.0-0' }}</td>
      <td class="text-nowrap">{{ deposit.customer.currency_type == 'usd' ? '$' : '¥' }} {{ deposit.remaining_amount | number:'1.0-0' }}</td>
    </tr>

    <!-- Total Row -->
    <tr *ngIf="!isLoading && deposits.length > 0" class="fw-bold bg-light-primary">
      <td colspan="3" class="text-end">TOTAL:</td>
      <td class="text-nowrap">{{ getCurrencySymbol() }} {{ getTotalAmount() | number:'1.0-0' }}</td>
      <td class="text-nowrap"></td>
      <td class="text-nowrap">{{ getCurrencySymbol() }} {{ getTotalAllocated() | number:'1.0-0' }}</td>
      <td class="text-nowrap">{{ getCurrencySymbol() }} {{ getTotalAvailable() | number:'1.0-0' }}</td>
    </tr>

  </tbody>
</table>
